/* LAVRYA 7.2.1 | source order: lavrya-premium.js, lavrya-editorial.js, lavrya-image-swatches.js, lavrya-mobile-menu.js */
/* LAVRYA v6. No third-party scripts, personal data, or invented stock/urgency. */
(() => {
  'use strict';
  const configNode = document.getElementById('LavryaConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const labels = config.labels || {};
  const root = String(config.root || '/').replace(/\/?$/, '/');
  const key = 'lavrya:wishlist:v1';
  const limit = 48;
  const live = document.getElementById('LavryaLive');
  const dialog = document.getElementById('LavryaWishlist');
  const cache = new Map();
  const pending = new Map();
  const renderVersion = new WeakMap();
  const activated = new WeakSet();
  let saved = [];
  let persistent = true;
  let previousFocus = null;
  let announcementTimer;
  const cleanHandles = (value) => Array.isArray(value)
    ? [...new Set(value.filter((v) => typeof v === 'string' && v.length <= 255 && /^[\p{L}\p{N}_-]+$/u.test(v)))].slice(0, limit) : [];
  try { saved = cleanHandles(JSON.parse(localStorage.getItem(key) || '[]')); }
  catch { persistent = false; }
  const announce = (message) => {
    if (!live) return;
    clearTimeout(announcementTimer);
    live.textContent = '';
    announcementTimer = setTimeout(() => { live.textContent = message || ''; }, 60);
  };
  function store() {
    try { localStorage.setItem(key, JSON.stringify(saved)); }
    catch { persistent = false; }
  }
  function syncButtons(scope = document) {
    const buttons = [];
    if (scope instanceof Element && scope.matches('[data-lv-wish]')) buttons.push(scope);
    buttons.push(...scope.querySelectorAll('[data-lv-wish]'));
    buttons.forEach((button) => {
      const isSaved = saved.includes(button.dataset.lvWish);
      const label = isSaved ? labels.saved : labels.save;
      button.hidden = false;
      button.setAttribute('aria-pressed', String(isSaved));
      button.setAttribute('aria-label', `${label}: ${button.dataset.lvTitle || ''}`);
      const text = button.querySelector('[data-lv-wish-label]');
      if (text && text.textContent !== label) text.textContent = label;
    });
    if (dialog) {
      const openButtons = [];
      if (scope instanceof Element && scope.matches('[data-lv-open-wishlist]')) openButtons.push(scope);
      openButtons.push(...scope.querySelectorAll('[data-lv-open-wishlist]'));
      openButtons.forEach((button) => { button.hidden = false; });
    }
    document.querySelectorAll('[data-lv-wish-count]').forEach((node) => {
      const count = String(saved.length);
      if (node.textContent !== count) node.textContent = count;
      node.hidden = saved.length === 0;
    });
  }
  function notifyChange(message) {
    syncButtons();
    document.querySelectorAll('[data-lv-wishlist]').forEach((view) => {
      if (!view.closest('dialog') || view.closest('dialog').open) renderWishlist(view);
    });
    announce(persistent ? message : `${message} ${labels.session || ''}`);
  }
  function toggle(handle) {
    if (!cleanHandles([handle]).length) return;
    if (saved.includes(handle)) {
      saved = saved.filter((item) => item !== handle);
      store(); notifyChange(labels.removed);
    } else {
      if (saved.length >= limit) { announce(labels.limit); return; }
      saved.push(handle); store(); notifyChange(labels.added);
    }
  }
  function remove(handle) {
    saved = saved.filter((item) => item !== handle);
    store(); notifyChange(labels.removed);
  }
  // Maximum four requests in flight, with an abortable per-request timeout.
  let active = 0;
  const queue = [];
  function runQueue() {
    while (active < 4 && queue.length) {
      const task = queue.shift(); active++;
      task().finally(() => { active--; runQueue(); });
    }
  }
  function getProduct(handle, refresh = false) {
    if (refresh) cache.delete(handle);
    if (cache.has(handle)) return Promise.resolve(cache.get(handle));
    if (pending.has(handle)) return pending.get(handle);
    const promise = new Promise((resolve, reject) => {
      queue.push(async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
            credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal,
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const product = await response.json();
          if (!product || typeof product.title !== 'string' || typeof product.handle !== 'string') throw new Error('Invalid product');
          cache.set(handle, product); resolve(product);
        } catch (error) { reject(error); }
        finally { clearTimeout(timeout); }
      });
      runQueue();
    }).finally(() => pending.delete(handle));
    pending.set(handle, promise);
    return promise;
  }
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function money(cents) {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    try { return new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency, currencyDisplay: 'code' }).format(amount / 100); }
    catch { return `${(amount / 100).toFixed(2)} ${config.currency || ''}`.trim(); }
  }
  function safeImage(value) {
    try {
      const url = new URL(typeof value === 'string' ? value : '', location.origin);
      return url.protocol === 'https:' || (url.origin === location.origin && url.protocol === 'http:') ? url.href : '';
    } catch { return ''; }
  }
  function removeButton(handle, title) {
    const button = element('button', 'lv-wishlist-card__remove', '×');
    button.type = 'button'; button.dataset.lvRemove = handle;
    button.setAttribute('aria-label', `${labels.remove}: ${title || handle}`);
    return button;
  }
  function fillCard(card, handle, product) {
    const href = `${root}products/${encodeURIComponent(handle)}`;
    const media = element('a', 'lv-wishlist-card__media'); media.href = href; media.tabIndex = -1; media.setAttribute('aria-hidden', 'true');
    const imageUrl = safeImage(product.featured_image);
    if (imageUrl) {
      const image = element('img');
      const imageSource = new URL(imageUrl); imageSource.searchParams.set('width', '500');
      image.src = imageSource.href; image.alt = ''; image.loading = 'lazy'; image.width = 400; image.height = 460;
      media.append(image);
    }
    const heading = element('h3'); const link = element('a', '', product.title); link.href = href; heading.append(link);
    const minPrice = money(product.price_min ?? product.price);
    const price = element('p', 'lv-wishlist-card__price', `${product.price_varies ? `${labels.from} ` : ''}${minPrice}`);
    const view = element('a', 'lv-wishlist-card__view', product.available === false ? labels.unavailable : labels.view); view.href = href;
    card.replaceChildren(media, heading, price, view, removeButton(handle, product.title));
    card.removeAttribute('aria-busy');
  }
  function fillError(card, handle, retry) {
    const box = element('div', 'lv-wishlist-card__error');
    box.append(element('p', '', labels.error));
    const button = element('button', 'lv-btn lv-btn--secondary', labels.retry); button.type = 'button'; button.addEventListener('click', retry, { once: true });
    const link = element('a', 'lv-wishlist-card__view', labels.view); link.href = `${root}products/${encodeURIComponent(handle)}`;
    box.append(button, document.createElement('br'), link);
    card.replaceChildren(box, removeButton(handle)); card.removeAttribute('aria-busy');
  }
  function renderWishlist(view) {
    activated.add(view);
    const version = (renderVersion.get(view) || 0) + 1; renderVersion.set(view, version);
    const grid = view.querySelector('[data-lv-wishlist-grid]');
    const empty = view.querySelector('[data-lv-wishlist-empty]');
    const status = view.querySelector('[data-lv-wishlist-status]');
    if (!grid) return;
    grid.replaceChildren(); if (empty) empty.hidden = saved.length !== 0;
    if (status) status.textContent = persistent ? '' : labels.session;
    saved.forEach((handle) => {
      const card = element('article', 'lv-wishlist-card'); grid.append(card);
      const load = (refresh = false) => {
        card.setAttribute('aria-busy', 'true');
        card.replaceChildren(element('div', 'lv-wishlist-card__loading', labels.loading), removeButton(handle));
        getProduct(handle, refresh).then((product) => {
          if (renderVersion.get(view) === version && card.isConnected) fillCard(card, handle, product);
        }).catch(() => {
          if (renderVersion.get(view) === version && card.isConnected) fillError(card, handle, () => load(true));
        });
      };
      load();
    });
  }
  function openWishlist(trigger) {
    if (!dialog) return;
    // The wishlist capture handler runs before the menu click listener. Close the
    // source menu explicitly so two modal dialogs never remain stacked.
    const sourceMenu = trigger?.closest('[data-lv-menu-dialog]');
    if (sourceMenu?.open) sourceMenu.close();
    previousFocus = sourceMenu ? (document.querySelector('[data-lv-menu-open]') || trigger) : trigger;
    dialog.querySelectorAll('[data-lv-wishlist]').forEach(renderWishlist);
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('lv-dialog-open');
  }
  function closeWishlist() { if (dialog?.open) dialog.close(); }
  if (dialog) {
    dialog.addEventListener('close', () => {
      document.body.classList.remove('lv-dialog-open');
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeWishlist();
    });
  }
  // Capture prevents native card click handlers from navigating when saving a bag.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const wish = event.target.closest('[data-lv-wish]');
    const opener = event.target.closest('[data-lv-open-wishlist]');
    const closer = event.target.closest('[data-lv-close-wishlist]');
    const remover = event.target.closest('[data-lv-remove]');
    if (wish || opener || closer || remover) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (wish) toggle(wish.dataset.lvWish);
      else if (opener) openWishlist(opener);
      else if (closer) closeWishlist();
      else if (remover) {
        const handle = remover.dataset.lvRemove;
        const view = remover.closest('[data-lv-wishlist]');
        remove(handle);
        // Keep keyboard focus meaningful after deleting its focused control.
        const next = view?.querySelector('[data-lv-remove], a');
        next?.focus({ preventScroll: true });
      }
      return;
    }
    document.querySelectorAll('[data-lv-nav][open]').forEach((nav) => {
      if (!nav.contains(event.target)) nav.open = false;
    });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || dialog?.open) return;
    const focused = document.activeElement;
    const nav = focused?.closest('[data-lv-nav][open]');
    if (nav) { nav.open = false; nav.querySelector(':scope > summary')?.focus(); event.preventDefault(); }
    else document.querySelectorAll('[data-lv-nav][open]').forEach((node) => { node.open = false; });
  });
  window.addEventListener('storage', (event) => {
    if (event.key !== key && event.key !== null) return;
    try { saved = cleanHandles(JSON.parse(event.newValue || '[]')); notifyChange(''); } catch { /* ignore corrupt external data */ }
  });
  const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  function initHelp(scope = document) {
    const roots = [];
    if (scope instanceof Element && scope.matches('[data-lv-help]')) roots.push(scope);
    roots.push(...scope.querySelectorAll('[data-lv-help]'));
    roots.forEach((help) => {
      if (help.dataset.lvReady) return;
      const input = help.querySelector('[data-lv-help-search]');
      const wrapper = help.querySelector('[data-lv-help-search-wrap]');
      if (!input || !wrapper) return;
      help.dataset.lvReady = 'true'; wrapper.hidden = false;
      const faqs = Array.from(help.querySelectorAll('[data-lv-faq]'));
      const topics = Array.from(help.querySelectorAll('[data-lv-help-topic]'));
      const initial = new Map(); let searching = false;
      const filter = () => {
        const terms = normalize(input.value).split(/\s+/).filter(Boolean);
        if (terms.length && !searching) faqs.forEach((faq) => initial.set(faq, faq.open));
        let matches = 0;
        faqs.forEach((faq) => {
          const text = normalize(faq.textContent);
          const match = terms.every((term) => text.includes(term));
          faq.hidden = !match;
          if (terms.length) faq.open = match;
          else if (searching) faq.open = initial.get(faq) || false;
          if (match) matches++;
        });
        topics.forEach((topic) => { topic.hidden = !Array.from(topic.querySelectorAll('[data-lv-faq]')).some((faq) => !faq.hidden); });
        const empty = help.querySelector('[data-lv-help-empty]'); if (empty) empty.hidden = matches > 0;
        searching = terms.length > 0;
      };
      let timer; input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(filter, 120); });
      help.querySelectorAll('.lv-help-topics a').forEach((link) => link.addEventListener('click', () => { clearTimeout(timer); input.value = ''; filter(); }));
    });
  }
  function initialize(scope = document) {
    syncButtons(scope); initHelp(scope);
    const views = [];
    if (scope instanceof Element && scope.matches('[data-lv-wishlist]')) views.push(scope);
    views.push(...scope.querySelectorAll('[data-lv-wishlist]'));
    views.forEach((view) => { if (!view.closest('dialog') && !activated.has(view)) renderWishlist(view); });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => { if (event.target instanceof Element) initialize(event.target); });
  // Observe added elements only; never rescan the entire page on every mutation.
  new MutationObserver((mutations) => {
    for (const mutation of mutations) for (const node of mutation.addedNodes) {
      if (!(node instanceof Element) || node.closest('[data-lv-wishlist]')) continue;
      if (node.matches('[data-lv-wish],[data-lv-open-wishlist],[data-lv-help],[data-lv-wishlist]') || node.querySelector('[data-lv-wish],[data-lv-open-wishlist],[data-lv-help],[data-lv-wishlist]')) initialize(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

;
/** LAVRYA 7: native commerce, progressive navigation, manual announcements and collection rails.
 * No autoplay, inferred stock, customer-count simulations, trackers or third-party dependencies.
 */
(() => {
  'use strict';
  const initialised = new WeakSet();
  const controllers = new WeakMap();
  const desktop = window.matchMedia('(min-width: 990px)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let activeDialog = null;
  let lastMenuTrigger = null;
  let headerObserver;
  let resizeFrame;
  let pageActive = true;

  function finishMenuClose(dialog) {
    if (dialog?.open) return; // ignore a queued close event after reopening
    if (activeDialog === dialog) activeDialog = null;
    document.documentElement.classList.remove('lv-menu-open');
    document.querySelectorAll('[data-lv-menu-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    if (lastMenuTrigger?.isConnected && lastMenuTrigger.getClientRects().length && !document.querySelector('dialog[open]')) lastMenuTrigger.focus({ preventScroll: true });
  }
  function closeMenu(dialog = activeDialog) {
    if (!dialog) return;
    if (dialog.open) dialog.close();
    finishMenuClose(dialog);
  }
  function closeMega(except) {
    document.querySelectorAll('[data-lv-mega]').forEach((node) => {
      if (node !== except) { controllers.get(node)?.disconnect(); node.open = false; }
    });
  }
  function bindMenu(dialog) {
    if (!dialog || initialised.has(dialog)) return;
    initialised.add(dialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeMenu(dialog);
      }
      if (event.target instanceof Element && event.target.closest('[data-lv-menu-close], a')) closeMenu(dialog);
    });
    dialog.addEventListener('close', () => finishMenuClose(dialog));
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), select, input:not([type=hidden]), summary, [tabindex="0"]'))
        .filter((node) => node.getClientRects().length > 0 && !node.closest('[hidden]'));
      const first = focusable[0]; const last = focusable.at(-1);
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    dialog.querySelectorAll('[data-lv-mobile-group]').forEach((group) => {
      group.addEventListener('toggle', () => {
        if (group.open) dialog.querySelectorAll('[data-lv-mobile-group]').forEach((other) => { if (other !== group) other.open = false; });
      });
    });
  }
  function bindMega(root = document) {
    root.querySelectorAll('[data-lv-mega]').forEach((group) => {
      if (initialised.has(group)) return;
      initialised.add(group);
      let openTimer; let closeTimer;
      const summary = group.querySelector(':scope > summary');
      const clear = () => { clearTimeout(openTimer); clearTimeout(closeTimer); };
      const open = () => { closeMega(group); group.open = true; };
      group.addEventListener('pointerenter', (event) => {
        if (!finePointer.matches || event.pointerType !== 'mouse') return;
        clear(); openTimer = setTimeout(open, 140);
      });
      group.addEventListener('pointerleave', (event) => {
        if (!finePointer.matches || event.pointerType !== 'mouse') return;
        clear(); closeTimer = setTimeout(() => { if (!group.contains(document.activeElement)) group.open = false; }, 220);
      });
      summary?.addEventListener('click', () => { clear(); closeMega(group); });
      group.addEventListener('toggle', () => { if (group.open) closeMega(group); });
      group.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!group.contains(document.activeElement) && !group.matches(':hover')) group.open = false; });
      });
      group.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && group.open) {
          clear(); group.open = false; summary?.focus(); event.preventDefault(); event.stopPropagation();
        }
        if (event.key === 'ArrowDown' && event.target === summary) {
          clear(); open(); group.querySelector('.lv-mega__panel a')?.focus(); event.preventDefault();
        }
      });
      controllers.set(group, { disconnect: clear });
    });
  }
  function bindAnnouncements(root = document) {
    root.querySelectorAll('[data-lv-announcements]').forEach((bar) => {
      if (initialised.has(bar)) return;
      initialised.add(bar);
      const messages = Array.from(bar.querySelectorAll('[data-lv-announcement]'));
      let index = 0;
      const show = (next) => {
        index = (next + messages.length) % messages.length;
        messages.forEach((message, i) => { message.hidden = i !== index; });
      };
      const prev = bar.querySelector('[data-lv-announce-prev]'); const next = bar.querySelector('[data-lv-announce-next]');
      if (messages.length > 1) {
        prev.hidden = false; next.hidden = false;
        prev.addEventListener('click', () => show(index - 1));
        next.addEventListener('click', () => show(index + 1));
      }
      controllers.set(bar, { show, disconnect() {} });
    });
  }
  function bindRails(root = document) {
    root.querySelectorAll('[data-lv-rail]').forEach((rail) => {
      if (initialised.has(rail)) return;
      const track = rail.querySelector('[data-lv-rail-track]');
      const controls = rail.querySelector('[data-lv-rail-controls]');
      if (!track || !controls) return;
      initialised.add(rail);
      const previous = controls.querySelector('[data-lv-rail-prev]'); const next = controls.querySelector('[data-lv-rail-next]');
      const count = controls.querySelector('[data-lv-rail-count]');
      let raf;
      const items = () => Array.from(track.children);
      const nearest = () => {
        const children = items(); const start = track.getBoundingClientRect().left;
        return children.reduce((best, item, i) => Math.abs(item.getBoundingClientRect().left - start) < Math.abs(children[best].getBoundingClientRect().left - start) ? i : best, 0);
      };
      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 2;
        controls.hidden = !overflow;
        const children = items(); if (!children.length) return;
        const index = nearest();
        // Use measured positions rather than a guessed fixed card width.
        const first = children[0].getBoundingClientRect(); const last = children.at(-1).getBoundingClientRect(); const bounds = track.getBoundingClientRect();
        previous.disabled = first.left >= bounds.left - 2;
        next.disabled = last.right <= bounds.right + 2;
        count.textContent = `${index + 1} / ${children.length}`;
      };
      const move = (step) => {
        const children = items(); const index = Math.max(0, Math.min(children.length - 1, nearest() + step));
        const item = children[index]; if (!item) return;
        const distance = item.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollBy({ left: distance, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      const observer = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
      observer?.observe(track); update();
      controllers.set(rail, { disconnect() { observer?.disconnect(); cancelAnimationFrame(raf); } });
    });
  }
  function measureHeader() {
    const header = document.querySelector('[data-lv-header]');
    headerObserver?.disconnect();
    if (!header) return;
    const measure = () => {
      const total = Math.ceil(header.getBoundingClientRect().height);
      const announcement = Math.ceil(header.querySelector('.lv-announcement-bar')?.getBoundingClientRect().height || 0);
      document.getElementById('header-group')?.style.setProperty('--lv-announcement-height', `${announcement}px`);
      document.body.style.setProperty('--header-height', `${total - announcement}px`);
      document.body.style.setProperty('--header-group-height', `${total}px`);
      document.documentElement.style.scrollPaddingTop = `${total - announcement + 16}px`;
    };
    measure();
    if ('ResizeObserver' in window) { headerObserver = new ResizeObserver(measure); headerObserver.observe(header); }
  }
  function checkNavFit() {
    const header = document.querySelector('[data-lv-header]');
    const inner = header?.querySelector('.lv-masthead__nav-inner');
    if (!header || !inner) return;
    header.removeAttribute('data-compact-nav');
    if (desktop.matches && inner.scrollWidth > inner.clientWidth + 1) header.setAttribute('data-compact-nav', '');
    if (desktop.matches && !header.hasAttribute('data-compact-nav')) closeMenu();
    if (!desktop.matches || header.hasAttribute('data-compact-nav')) closeMega();
  }
  function initialise() {
    bindMenu(document.querySelector('[data-lv-menu-dialog]'));
    bindMega(); bindAnnouncements(); bindRails(); checkNavFit(); measureHeader();
    const enquiry = new URLSearchParams(location.search).get('product');
    const message = document.querySelector('.lv-form textarea[name="contact[body]"]');
    if (enquiry && enquiry.length < 250 && message && !message.value) message.value = `I have a question about ${enquiry}.\n\n`;
  }
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (!target.closest('[data-lv-mega]')) closeMega();
    const trigger = target.closest('[data-lv-menu-open]');
    if (trigger) {
      const dialog = document.querySelector('[data-lv-menu-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault(); bindMenu(dialog); closeMega(); lastMenuTrigger = trigger;
      if (!dialog.open) { dialog.showModal(); dialog.querySelector('lavrya-mobile-navigation')?.reset?.(); activeDialog = dialog; trigger.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('lv-menu-open'); }
      return;
    }
    if (target.closest('[data-lv-search-open]')) {
      const search = document.getElementById('search-modal');
      if (typeof search?.showDialog === 'function') { event.preventDefault(); closeMenu(); search.showDialog(); }
      // Otherwise the ordinary search URL remains navigable.
    }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && activeDialog?.open) closeMenu(); });
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-lv-rail],[data-lv-mega],[data-lv-announcements]').forEach((node) => controllers.get(node)?.disconnect());
    if (activeDialog && event.target.contains(activeDialog)) closeMenu();
  });
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('[data-lv-announcement]'); const bar = item?.closest('[data-lv-announcements]');
    if (bar && item) controllers.get(bar)?.show(Array.from(bar.querySelectorAll('[data-lv-announcement]')).indexOf(item));
  });
  window.addEventListener('resize', () => {
    cancelAnimationFrame(resizeFrame); resizeFrame = requestAnimationFrame(checkNavFit);
  }, { passive: true });
  window.addEventListener('pagehide', () => { pageActive = false; headerObserver?.disconnect(); closeMenu(); });
  window.addEventListener('pageshow', () => { pageActive = true; checkNavFit(); measureHeader(); });
  document.fonts?.ready.then(() => { if (pageActive) { checkNavFit(); measureHeader(); } });
  initialise();
})();

;
/** LAVRYA 7.2.1: shared photographic swatch layout for every product card.
 * Progressive enhancement: swatches are ordinary variant links without this script.
 */
(() => {
 'use strict';
 if (customElements.get('lavrya-card-swatches')) return;
 class CardSwatches extends HTMLElement {
  connectedCallback() {
   this._abort?.abort(); this._abort = new AbortController(); this._generation = 0;
   this._expanded = this.dataset.lvExpanded === 'true';
   this.refresh();
   this.addEventListener('click', this._click, {signal:this._abort.signal});
   this._observer?.disconnect();
   if ('ResizeObserver' in window) { this._observer = new ResizeObserver(() => this._layout()); this._observer.observe(this); }
   this._layout();
  }
  disconnectedCallback() { this._generation++; this._abort?.abort(); this._observer?.disconnect(); }
  refresh(expanded = this._expanded) {
   this._items = [...this.querySelectorAll('[data-lv-swatch-item]')];
   this._more = this.querySelector('[data-lv-more-swatches]');
   this._expanded = Boolean(expanded);
   this.dataset.lvExpanded = String(this._expanded);
   this._layout();
  }
  _layout() {
   if (!this._more || !this.clientWidth) return;
   const capacity = Math.max(1, Math.floor((this.clientWidth + 4) / 48));
   const needsMore = this._items.length > capacity;
   const shown = needsMore && !this._expanded ? Math.max(1, capacity - 1) : this._items.length;
   this._items.forEach((item,i) => { item.hidden = i >= shown; });
   this._more.hidden = !needsMore;
   this._more.textContent = this._expanded ? '−' : `+${this._items.length - shown}`;
   this._more.setAttribute('aria-expanded', String(this._expanded));
   this._more.setAttribute('aria-label', this._expanded ? this.dataset.lessLabel : this.dataset.showLabel);
  }
  _click = (event) => {
   const target = event.target instanceof Element ? event.target : null;
   if (!target) return;
   if (target.closest('[data-lv-more-swatches]')) { event.preventDefault(); event.stopPropagation(); this._expanded = !this._expanded; this.dataset.lvExpanded = String(this._expanded); this._layout(); return; }
   const swatch = target.closest('[data-lv-card-swatch]');
   if (!swatch || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !swatch.dataset.image || !swatch.dataset.price) return;
   const card = this.closest('.lv-edit-card'); const image = card?.querySelector('.lv-edit-card__image');
   if (!card || !image) return;
   event.preventDefault();
   const generation = ++this._generation;
   this.setAttribute('aria-busy','true');
   const candidate = new Image();
   candidate.onload = () => {
    if (!this.isConnected || generation !== this._generation) return;
    image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = candidate.src;
    image.alt = `${card.querySelector('h3')?.textContent.trim() || ''} — ${swatch.dataset.colour}`;
    card.querySelectorAll('[data-lv-card-link]').forEach(link => { link.href = swatch.href; });
    const price = card.querySelector('.lv-edit-card__price'); if (price) price.textContent = swatch.dataset.price;
    const badge = card.querySelector('[data-lv-card-badge]'); if (badge) badge.hidden = swatch.dataset.available === 'true';
    this._items.forEach(item => { if(item === swatch) item.setAttribute('aria-current','true'); else item.removeAttribute('aria-current'); });
    card.classList.add('is-variant-picked'); this.removeAttribute('aria-busy');
    this.querySelector('[data-lv-swatch-status]').textContent = `${swatch.dataset.colour}. ${swatch.dataset.price}`;
   };
   candidate.onerror = () => {
    if (!this.isConnected || generation !== this._generation) return;
    this.removeAttribute('aria-busy');
    // Keep the prior image, price and link together; a second click follows the correct variant link.
    swatch.removeAttribute('data-image');
    this.querySelector('[data-lv-swatch-status]').textContent = document.documentElement.lang.startsWith('nl') ? 'Foto niet beschikbaar. Open de kleur opnieuw om de productpagina te bekijken.' : 'Photo unavailable. Select this colour again to open its product page.';
   };
   candidate.src = swatch.dataset.image;
  };
 }
 customElements.define('lavrya-card-swatches', CardSwatches);
})();

;
/** LAVRYA 7.2: one navigation level at a time. Native links remain usable without JS. */
(() => {
  'use strict';
  if (customElements.get('lavrya-mobile-navigation')) return;
  class MobileNavigation extends HTMLElement {
    connectedCallback() {
      this._abort?.abort();
      this._abort = new AbortController();
      const { signal } = this._abort;
      this._levels = [...this.querySelectorAll('[data-lv-mobile-level]')];
      this._root = this.querySelector('[data-lv-mobile-level="root"]');
      this._stack = [];
      this.querySelectorAll('[data-lv-mobile-next]').forEach(link => link.setAttribute('role', 'button'));
      this.addEventListener('click', this._click, { signal });
      this.addEventListener('keydown', event => {
        const next = event.target instanceof Element ? event.target.closest('[data-lv-mobile-next]') : null;
        if (event.key === ' ' && next) { event.preventDefault(); next.click(); }
        if (event.key === 'ArrowLeft' && this._stack.length) { event.preventDefault(); this._back(); }
      }, { signal });
      this.closest('dialog')?.addEventListener('close', () => this.reset(), { signal });
      this.reset();
    }
    disconnectedCallback() { this._abort?.abort(); }
    reset() {
      this._stack = [];
      this._levels?.forEach(level => { level.hidden = level !== this._root; });
      this.querySelectorAll('[data-lv-mobile-next]').forEach(link => link.setAttribute('aria-expanded', 'false'));
      if (this._root) this._root.scrollTop = 0;
      const dialog = this.closest('dialog');
      if (dialog) dialog.dataset.lvMenuDepth = '0';
      const body = this.closest('.lv-menu-dialog__body');
      if (body) body.scrollTop = 0;
    }
    _click = event => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const next = target.closest('[data-lv-mobile-next]');
      if (next && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
        const panel = this._levels.find(level => level.id === next.getAttribute('aria-controls'));
        if (!panel) return;
        event.preventDefault(); event.stopPropagation();
        this._stack.push({ level: next.closest('[data-lv-mobile-level]'), trigger: next });
        next.setAttribute('aria-expanded', 'true');
        this._show(panel);
        panel.querySelector('[data-lv-mobile-back]')?.focus({ preventScroll: true });
      } else if (target.closest('[data-lv-mobile-back]')) {
        event.preventDefault(); event.stopPropagation(); this._back();
      }
    };
    _show(panel) {
      this._levels.forEach(level => { level.hidden = level !== panel; });
      panel.scrollTop = 0;
      const dialog = this.closest('dialog');
      if (dialog) dialog.dataset.lvMenuDepth = String(this._stack.length);
      const body = this.closest('.lv-menu-dialog__body');
      if (body) body.scrollTop = 0;
    }
    _back() {
      const previous = this._stack.pop();
      if (!previous) return;
      previous.trigger.setAttribute('aria-expanded', 'false');
      this._show(previous.level);
      previous.trigger.focus({ preventScroll: true });
    }
  }
  customElements.define('lavrya-mobile-navigation', MobileNavigation);
})();


/** Five-product, native-scroll menu slider. No external carousel dependency. */
(() => {
  'use strict';
  if (customElements.get('lavrya-menu-products')) return;
  class MenuProducts extends HTMLElement {
    connectedCallback() {
      this._abort?.abort();
      this._abort = new AbortController();
      this._track = this.querySelector('.lv-menu-products__track');
      this._controls = this.querySelector('[data-lv-slider-controls]');
      this._prev = this.querySelector('[data-lv-slider-prev]');
      this._next = this.querySelector('[data-lv-slider-next]');
      if (!this._track || !this._controls || !this._prev || !this._next) return;
      const { signal } = this._abort;
      this._prev.addEventListener('click', () => this._move(-1), { signal });
      this._next.addEventListener('click', () => this._move(1), { signal });
      this._track.addEventListener('scroll', () => {
        cancelAnimationFrame(this._frame);
        this._frame = requestAnimationFrame(() => this._update());
      }, { passive:true, signal });
      this._observer?.disconnect();
      if ('ResizeObserver' in window) {
        this._observer = new ResizeObserver(() => this._update());
        this._observer.observe(this._track);
      }
      this._update();
    }
    disconnectedCallback() {
      this._abort?.abort(); this._observer?.disconnect(); cancelAnimationFrame(this._frame);
    }
    _update() {
      if (!this._track?.clientWidth) return;
      const limit = this._track.scrollWidth - this._track.clientWidth;
      const position = Math.abs(this._track.scrollLeft);
      this._controls.hidden = limit < 2;
      this._prev.disabled = position < 2;
      this._next.disabled = position >= limit - 2;
    }
    _move(direction) {
      const card = this._track?.firstElementChild;
      if (!card) return;
      const style = getComputedStyle(this._track);
      const sign = style.direction === 'rtl' ? -1 : 1;
      const distance = card.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._track.scrollBy({ left:direction * sign * distance, behavior:reduced ? 'instant' : 'smooth' });
    }
  }
  customElements.define('lavrya-menu-products', MenuProducts);
})();
